import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Background } from '../../core/components/Background';
import { FlexContainer } from '../../core/components/FlexContainer';
import { TextInput } from '../../core/components/TextArea';
import { Button } from '../../core/components/Button';
import { useNavigate } from 'react-router-dom';
import { customAlphabet } from 'nanoid';
import { REDIRECT_GAME_ID, USERNAME_KEY } from '../../core/util/LocalStorageKeys';
import { useCallback, useState } from 'react';
import { Contact3DHeader } from '../components/Contact3DHeader';
import { ScreenSize, useScreenSize } from '../../core/util/MediaQueries';
const GAME_ID_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const EXTENDED_GAME_ID_ALPHABET = GAME_ID_ALPHABET + 'IO';
export const Contact3DStartPage = () => {
    var _a, _b;
    const [gameId, setGameId] = useState((_a = sessionStorage.getItem(REDIRECT_GAME_ID)) !== null && _a !== void 0 ? _a : '');
    const [username, setUsername] = useState((_b = localStorage.getItem(USERNAME_KEY)) !== null && _b !== void 0 ? _b : '');
    const navigate = useNavigate();
    const screenSize = useScreenSize();
    const testKey = useCallback((key) => EXTENDED_GAME_ID_ALPHABET.includes(key), []);
    const onChange = useCallback((e) => {
        setGameId(e.target.value.toUpperCase().split('').filter((char) => testKey(char)).join('').slice(0, 9));
    }, [setGameId, testKey]);
    const usernameOnChange = useCallback((e) => {
        setUsername(e.target.value.split('').filter((char) => /[a-zA-Z0-9]/.test(char)).join(''));
    }, [setUsername]);
    const buttonOnClick = () => {
        if (username === undefined || username.length <= 0) {
            return;
        }
        localStorage.setItem(`${USERNAME_KEY}`, username);
        if (gameId !== undefined && gameId.length > 0) {
            navigate(`/contact/${gameId}`);
        }
        else {
            navigate(`/contact/${generateGameId()}`);
        }
    };
    const fontSize = screenSize === ScreenSize.Small ? 16 : 25;
    const inputHeight = screenSize === ScreenSize.Small ? '50px' : '88px';
    const inputBorderWidth = screenSize === ScreenSize.Small ? '2px' : '3px';
    const gap = screenSize === ScreenSize.Small ? '15px' : '30px';
    const inputBorderRadius = screenSize === ScreenSize.Small ? '12px' : '20px';
    const buttonStyle = { height: inputHeight, flexBasis: '50%' };
    return _jsxs(Background, { imgFilePath: 'images/contact-3d-bg-create-game.png', children: [_jsx(Contact3DHeader, { variant: 'primary' }), _jsx(FlexContainer, { style: { width: '100%', margin: '17vh 0' }, children: _jsxs(FlexContainer, { gap: gap, style: { width: '100%', maxWidth: '836px', padding: '0 30px', margin: '0 auto' }, children: [_jsx(TextInput, { type: 'input', value: username, placeholder: "Username", fontSize: fontSize, onChange: usernameOnChange, style: { width: '100%', height: inputHeight, border: `${inputBorderWidth} solid #FFB3DE`, borderRadius: inputBorderRadius } }), _jsx(TextInput, { type: 'input', value: gameId, placeholder: "Game ID (optional)", fontSize: fontSize, onChange: onChange, style: { width: '100%', height: inputHeight, border: `${inputBorderWidth} solid #FFB3DE`, borderRadius: inputBorderRadius } }), _jsxs(FlexContainer, { horizontal: true, gap: gap, children: [_jsx(Button, { color: 'pink', variant: 'primary', style: buttonStyle, onClick: buttonOnClick, text: 'Join game', fontSize: fontSize }), _jsx(Button, { color: 'pink', variant: 'secondary', style: buttonStyle, onClick: buttonOnClick, text: 'Create game', fontSize: fontSize })] })] }) })] });
};
let nanoId = undefined;
function generateGameId() {
    if (nanoId === undefined) {
        nanoId = customAlphabet(GAME_ID_ALPHABET);
    }
    return nanoId(6);
}
//# sourceMappingURL=Contact3DStartPage.js.map